import { Component } from '@angular/core';
import { JurisdictionsService } from '../../../../services/api/general-settings/jurisdictions.service';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { RouteService } from '../../../../services/route.service';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';

@Component({
  selector: 'app-jurisdiction-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './jurisdiction-index-page.component.html',
  styleUrl: './jurisdiction-index-page.component.scss'
})
export class JurisdictionIndexPageComponent {
  list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected jurisdictionsService: JurisdictionsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Jurisdictions',
      cardTitle: 'Manage Jurisdictions',
      addNewItemButton: {
        type: 'success',
        title: 'Add Jurisdiction',
        onClick: () => {
          this.routeService.jurisdictionCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'type',
            header: 'Type',
            filter: 'select',
            filterOptionsSource: 'jurisdactionTypes',
            value: (item: any) => {
              return item.type;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View jurisdiction details',
                onClick: (item: any) => {
                  this.routeService.jurisdictionDetail(item.jurisdictionId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit jurisdiction',
                onClick: (item: any) => {
                  this.routeService.jurisdictionUpdate(item.jurisdictionId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete category',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((category: any) => category.categoryId !== item.categoryId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.jurisdictionsService.list(options),
      responseListModelName: 'jurisdictions',
    }
  }
}
